export interface IErrorPayload {
  status: number;
  message: string;
  errorMessage?: string;
}

export function isInstanceOfIErrorPayload(object: unknown): object is IErrorPayload {
  return typeof object === 'object' && object !== null && 'status' in object && 'message' in object;
}
